import { BadgeCheck, Headphones, ShieldCheck, Zap } from "lucide-react";

const BADGES = [
  { code: "secure", label: "Paiement sécurisé", icon: ShieldCheck, color: "#0052FF" },
  { code: "fast", label: "Traitement rapide", icon: Zap, color: "#F59E0B" },
  { code: "support", label: "Support 7j/7", icon: Headphones, color: "#10B981" },
  { code: "warranty", label: "Garantie 2 à 7 jours", icon: BadgeCheck, color: "#6366F1" },
];

export function PaymentBadges({ size = "md", className = "" }) {
  const compact = size === "sm";
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="payment-badges">
      {BADGES.map(({ code, label, icon: Icon, color }) => (
        <span
          key={code}
          data-testid={`payment-badge-${code}`}
          className={`flex items-center gap-1.5 rounded-lg border border-line bg-white font-bold text-ink ${
            compact ? "px-2 py-1 text-[10px]" : "px-3 py-2 text-xs"
          }`}
        >
          <Icon className={compact ? "h-3 w-3" : "h-4 w-4"} style={{ color }} />
          {label}
        </span>
      ))}
    </div>
  );
}

export default PaymentBadges;
